


































































import LandingHeader from '@/components/LandingHeaderB.vue';
import LoggedAccountConfirmation from '@/components/LoggedAccountConfirmation.vue';
import { Loading, Logo } from '@/components/ds';
import Vue from 'vue';

import accountsIframe, {
  AccountsPages,
  LoginWithIframeData,
  ProductName,
  SignMethods,
} from '@/helpers/accountsIframe';
import Analytics from '@/helpers/analytics/analytics';
import { isAccountConfirmed, saveConfirmedAccount } from '@/helpers/confirmedAccountStorage';
import { SignUpMethod } from '@/helpers/westeros';
import { AnalyticsActions } from '@/store/modules/analytics/actions';
import { UserInfo } from '@/store/modules/user/state';
import VueMarkdown from 'vue-markdown';

declare module 'vue/types/vue' {
  interface Vue {
    isLoading: Boolean;
  }
}

interface IInitAdmissionUser {
  name?: string;
  email?: string;
  phone?: string;
  accountId?: number;
}

export default Vue.extend({
  components: {
    LandingHeader,
    LoggedAccountConfirmation,
    VueMarkdown,
    Loading,
    Logo,
  },
  data() {
    return {
      isLoading: false,
      showAccountConfirmation: false,
      confirmationAccount: { name: '', email: '' },
    };
  },
  computed: {
    isLoggedInAccounts(): boolean {
      return accountsIframe.isLogged();
    },
    tokenD(): string | undefined {
      return accountsIframe.getTokenD();
    },
    profileName(): string | undefined {
      return accountsIframe.getProfileName();
    },
    isFullyLogged(): boolean | undefined {
      return !!(this.isLoggedInAccounts && this.tokenD && this.profileName);
    },
    userFromStore(): UserInfo {
      return this.$store.getters.user;
    },
    isLoginSuccess(): boolean | undefined {
      return this.$store.getters.isLoginSuccess;
    },
  },
  mounted() {
    // sessão já ativa pode ser de outra pessoa: confirma antes do SET_USER e do iframe.
    // Sem e-mail não há o que conferir, e a confirmação não seria gravada
    const { name, email } = accountsIframe.getPocketProfile() || {};

    if (this.isLoggedInAccounts && email && !isAccountConfirmed(email)) {
      this.confirmationAccount = { name: name || '', email: email || '' };
      this.showAccountConfirmation = true;
      return;
    }

    this.startSignUp();
  },
  methods: {
    startSignUp(): void {
      this.getAccountsInfo();

      this.loadAccountsAsIframe();
    },
    async confirmLoggedAccount(): Promise<void> {
      saveConfirmedAccount(this.confirmationAccount.email);
      this.showAccountConfirmation = false;
      // o container do iframe só existe no próximo render
      await this.$nextTick();
      this.startSignUp();
    },
    switchLoggedAccount(): void {
      this.showAccountConfirmation = false;
      this.handleSignOut();
    },
    loadAccountsAsIframe(): void {
      const accountsUrl = `${process.env.VUE_APP_ACCOUNTS_URL}/${
        this.isLoggedInAccounts
          ? AccountsPages.COMPLETE_REGISTRATION
          : AccountsPages.COMPLETE_SIGN_UP
      }`;

      const params: LoginWithIframeData = {
        url: accountsUrl,
        productName: ProductName.UNDERGRAD_DESCOMPLICA,
        hideHeaders: true,
        hideFooter: false,
        hideSocialMedia: false,
        onSuccess: this.iframeOnSuccess,
      };

      accountsIframe.loginWithIframe(
        params,
        '.sign-up__iframe__iframe-container',
        'sign-up__iframe__iframe-container__accounts-iframe',
      );
    },
    async iframeOnSuccess(): Promise<void> {
      try {
        this.isLoading = true;
        this.getAccountsInfo();

        const user = this.userFromStore;
        const { name, email, phone } = user;
        // confirmou no modal ou acabou de se identificar no iframe: a seleção de curso não pergunta de novo
        saveConfirmedAccount(email);
        const { signMethod, id } = accountsIframe.getPocketProfile() || {};
        const pocketTokenD = accountsIframe.getTokenD();

        try {
          await this.$store.dispatch('GET_USER', {
            name,
            email,
            phone,
            signMethod: SignUpMethod.accounts,
          });

          await this.startExistentUser({ name, email });
          return;
        } catch (error) {
          // suppress error
        }

        await this.initDexUser({ tokenD: pocketTokenD });

        if (signMethod === SignMethods.SIGN_UP || signMethod === SignMethods.COMPLETED_PROFILE) {
          await this.initAdmissionsUser({
            name,
            email,
            phone,
            accountId: id,
          });
          return;
        }
        this.$emit('forceRerender');
      } catch (error) {
        // supress error
      } finally {
        this.isLoading = false;
      }
    },
    async initAdmissionsUser({ name, email, phone, accountId }: IInitAdmissionUser): Promise<void> {
      await this.$store.dispatch('UPSERT_USER', {
        user: {
          name,
          accountId,
          email,
          phone,
          signupMethod: SignUpMethod.accounts,
        },
      });

      await this.startExistentUser({ name, email });
    },
    async initDexUser(payload: { tokenD?: string }): Promise<void> {
      if (!payload.tokenD) return;

      try {
        await this.$store.dispatch('GET_OR_CREATE_DEX_USER', payload);
      } catch (error) {
        // suppress error
      }
    },
    async startExistentUser({
      name,
      email,
    }: {
      name?: string | undefined;
      email?: string | undefined;
    }): Promise<void> {
      const pocketProfile = accountsIframe.getPocketProfile();
      await this.$store.dispatch('CREATE_AUTH_TOKEN');
      if (pocketProfile) {
        const accountId = pocketProfile.id.toString();
        Analytics.identify({ id: accountId, email, name });
        window.POCKET.alias(email || accountId);
      }

      if (this.isLoginSuccess) {
        try {
          await this.$store.dispatch('PULL_CURRENT_ADMISSION');
        } catch {
          await this.$store.dispatch('CREATE_NEW_ADMISSION');
          await this.$store.dispatch(AnalyticsActions.SUBSCRIPTION_COMPLETED);
          Analytics.trackFirstAccess();
        }
      }

      await this.$store.dispatch('PULL_PIPELINE');
      await this.$store.dispatch('START_PIPELINE');
    },
    async getAccountsInfo(): Promise<void> {
      const tokenD = accountsIframe.getTokenD();

      if (tokenD) {
        const pocketProfile = accountsIframe.getPocketProfile();

        if (pocketProfile) {
          const { name, phone, email } = pocketProfile;

          this.$store.commit('SET_USER', {
            name,
            email,
            phone,
            signupMethod: SignUpMethod.accounts,
          });
        }
      }
    },
    handleSignOut(): void {
      accountsIframe.logout();
      this.$emit('forceRerender');
    },
  },
});
